module.exports = __webpack_public_path__ + "static/img/ly_alt.585db635.png";